import CheckoutPage from './flow/CheckoutPage.vue';
import QuickCheckoutPage from './flow/QuickCheckoutPage.vue';

export default [
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutPage,
    meta: {
      title: 'Finaliser la commande'
    }
  },
  {
    path: '/checkout/quick',
    name: 'quick-checkout',
    component: QuickCheckoutPage,
    meta: {
      title: 'Paiement'
    }
  }
];
